// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__5d3Zn","active":"NavigationItem_active__cBpCB"};